import {
    AddNodeBranchDTO,
    AddNodeDTO,
    CountInNode,
    HistoryEvent,
    OrganizationNode,
    OrganizationNodeDTO,
    OrganizationNodeImageSocket,
    OrganizationNodeSocket,
    OrganizationSettings,
    createOrganizationDTO,
} from './';

export enum ORGANIZATION {
    ADD_NODE_REQUEST = 'ORGANIZATION.ADD_NODE_REQUEST',
    ADD_NODE_SUCCESS = 'ORGANIZATION.ADD_NODE_SUCCESS',
    ADD_NODE_FAILURE = 'ORGANIZATION.ADD_NODE_FAILURE',

    DELETE_NODE_REQUEST = 'ORGANIZATION.DELETE_NODE_REQUEST',
    DELETE_NODE_SUCCESS = 'ORGANIZATION.DELETE_NODE_SUCCESS',
    DELETE_NODE_FAILURE = 'ORGANIZATION.DELETE_NODE_FAILURE',

    EDIT_NODE_REQUEST = 'ORGANIZATION.EDIT_NODE_REQUEST',
    EDIT_NODE_SUCCESS = 'ORGANIZATION.EDIT_NODE_SUCCESS',
    EDIT_ROOT_SUCCESS = 'ORGANIZATION.EDIT_ROOT_SUCCESS',
    EDIT_NODE_FAILURE = 'ORGANIZATION.EDIT_NODE_FAILURE',

    HISTORY_REQUEST = 'ORGANIZATION.HISTORY_REQUEST',
    HISTORY_SUCCESS = 'ORGANIZATION.HISTORY_SUCCESS',
    HISTORY_FAILURE = 'ORGANIZATION.HISTORY_FAILURE',

    GET_DETAILS_REQUEST = 'ORGANIZATION.GET_DETAILS_REQUEST',
    GET_DETAILS_SUCCESS = 'ORGANIZATION.GET_DETAILS_SUCCESS',
    GET_DETAILS_FAILURE = 'ORGANIZATION.GET_DETAILS_FAILURE',

    GET_ORGANIZATION_REQUEST = 'ORGANIZATION.GET_ORGANIZATION_REQUEST',
    GET_ORGANIZATION_SUCCESS = 'ORGANIZATION.GET_ORGANIZATION_SUCCESS',
    GET_ORGANIZATION_FAILURE = 'ORGANIZATION.GET_ORGANIZATION_FAILURE',

    UPDATE_NODE_IMAGE = 'ORGANIZATION.UPDATE_NODE_IMAGE',
    UPDATE_ORGANIZATION_IMAGE = 'ORGANIZATION.UPDATE_ORGANIZATION_IMAGE',
    UPDATE_COUNT_OF_RESIDENTS_BY_SOKET = 'ORGANIZATION.UPDATE_COUNT_OF_RESIDENTS',
    UPDATE_COUNT_OF_DEVICES_BY_SOKET = 'ORGANIZATION.UPDATE_COUNT_OF_DEVICES',

    GET_ALL_NODES_INFO_REQUEST = 'ORGANIZATION.GET_ALL_NODES_INFO_REQUEST',
    GET_ALL_NODES_INFO_SUCCESS = 'ORGANIZATION.GET_ALL_NODES_INFO_SUCCESS',
    GET_ALL_NODES_INFO_FAILURE = 'ORGANIZATION.GET_ALL_NODES_INFO_FAILURE',

    SET_SETTINGS = 'ORGANIZATION.SET_SETTINGS',
    PAGE_ACTIVE = 'ORGANIZATION.PAGE_ACTIVE',

    ADD_NODE_BRANCH_REQUEST = 'ORGANIZATION.ADD_NODE_BRANCH_REQUEST',
    ADD_NODE_BRANCH_SUCCESS = 'ORGANIZATION.ADD_NODE_BRANCH_SUCCESS',
    ADD_NODE_BRANCH_FAILURE = 'ORGANIZATION.ADD_NODE_BRANCH_BRANCH_FAILURE',
    RECEIVE_NODE_BRANCH_ADDED_BY_SOCKET = 'ORGANIZATION.RECEIVE_NODE_BRANCH_ADDED_BY_SOCKET',
    UPDATE_ORGANIZATION_NODE_BY_SOKET = 'ORGANIZATION.UPDATE_ORGANIZATION_NODE_BY_SOKET',
    UPDATE_ORGANIZATION_BY_SOKET = 'ORGANIZATION.UPDATE_ORGANIZATION_BY_SOKET',

    CREATE_ORGANIZATION = 'ORGANIZATION.CREATE_ORGANIZATION',
    CREATE_ORGANIZATION_SUCCESS = 'ORGANIZATION.CREATE_ORGANIZATION_SUCCESS',
    CREATE_ORGANIZATION_FAILURE = 'ORGANIZATION.CREATE_ORGANIZATION_FAILURE',

    SET_ORGANIZATION_ID_FROM_TOKEN = 'ORGANIZATION.SET_ORGANIZATION_ID_FROM_TOKEN',
}

export interface IOrganizationGetDetailsRequest {
    type: typeof ORGANIZATION.GET_DETAILS_REQUEST;
    payload: { nodeId: number };
}

export interface IOrganizationGetDetailsSuccess {
    type: typeof ORGANIZATION.GET_DETAILS_SUCCESS;
    payload: { data: any; nodeId: number };
}

export interface IOrganizationGetDetailsFailure {
    type: typeof ORGANIZATION.GET_DETAILS_FAILURE;
    payload: any;
}

export interface IOrganizatioGetInfoRequest {
    type: typeof ORGANIZATION.GET_ORGANIZATION_REQUEST;
    payload: { blocking: boolean };
}

export interface IOrganizationGetInfoSuccess {
    type: typeof ORGANIZATION.GET_ORGANIZATION_SUCCESS;
    payload: OrganizationNodeDTO;
}

export interface IOrganizationGetInfoFailure {
    type: typeof ORGANIZATION.GET_ORGANIZATION_FAILURE;
    payload: any;
}

export interface IOrganizationInfoResponce {
    organization: OrganizationNode;
}
export interface IAddNodeRequest {
    type: typeof ORGANIZATION.ADD_NODE_REQUEST;
    payload: { node: AddNodeDTO };
}

export interface IAddNodeSuccess {
    type: typeof ORGANIZATION.ADD_NODE_SUCCESS;
    payload: { id: number; data: AddNodeDTO };
}

export interface IAddNodeFailure {
    type: typeof ORGANIZATION.ADD_NODE_FAILURE;
    payload: any;
}

export interface IDeleteNodeRequest {
    type: typeof ORGANIZATION.DELETE_NODE_REQUEST;
    payload: { nodeId: number };
}

export interface IDeleteNodeSuccess {
    type: typeof ORGANIZATION.DELETE_NODE_SUCCESS;
    payload: any;
}

export interface IDeleteNodeFailure {
    type: typeof ORGANIZATION.DELETE_NODE_FAILURE;
    payload: any;
}

export interface IEditNodeRequest {
    type: typeof ORGANIZATION.EDIT_NODE_REQUEST;
    payload: { nodeId: number; node: OrganizationNode };
}
export interface IEditNodeSuccess {
    type: typeof ORGANIZATION.EDIT_NODE_SUCCESS;
    payload: any;
}

export interface IEditRootNodeSuccess {
    type: typeof ORGANIZATION.EDIT_ROOT_SUCCESS;
    payload: any;
}
export interface IEditNodeFailure {
    type: typeof ORGANIZATION.EDIT_NODE_FAILURE;
    payload: any;
}

export interface ICreateOrganization {
    type: typeof ORGANIZATION.CREATE_ORGANIZATION;
    payload: createOrganizationDTO;
}
export interface ICreateOrganizationSuccess {
    type: typeof ORGANIZATION.CREATE_ORGANIZATION_SUCCESS;
    payload: any;
}
export interface ICreateOrganizationFailure {
    type: typeof ORGANIZATION.CREATE_ORGANIZATION_FAILURE;
    payload: any;
}

export interface IGetOrganizationHistoryRequest {
    type: typeof ORGANIZATION.HISTORY_REQUEST;
    payload: string;
}

export interface IGetOrganizationHistorySuccess {
    type: typeof ORGANIZATION.HISTORY_SUCCESS;
    payload: HistoryEvent[];
}

export interface IGetOrganizationGHistoryFailure {
    type: typeof ORGANIZATION.HISTORY_FAILURE;
    payload: any;
}

export interface IUpdateOrganizationNodeBySocket {
    type: typeof ORGANIZATION.UPDATE_ORGANIZATION_NODE_BY_SOKET;
    payload: OrganizationNodeSocket;
}

export interface IUpdateOrganizationBySocket {
    type: typeof ORGANIZATION.UPDATE_ORGANIZATION_BY_SOKET;
    payload: OrganizationNodeSocket;
}

export interface ISetSettingsOrganization {
    type: typeof ORGANIZATION.SET_SETTINGS;
    payload: OrganizationSettings;
}

export interface IUpdateOrganizationNodeImageBySocket {
    type: typeof ORGANIZATION.UPDATE_NODE_IMAGE;
    payload: OrganizationNodeImageSocket;
}

export interface IUpdateOrganizationImageBySocket {
    type: typeof ORGANIZATION.UPDATE_ORGANIZATION_IMAGE;
    payload: OrganizationNodeImageSocket;
}

export interface IOrganizationPageActive {
    type: typeof ORGANIZATION.PAGE_ACTIVE;
    payload: boolean;
}

export interface IUpdateCountOfResidentsBySocket {
    type: typeof ORGANIZATION.UPDATE_COUNT_OF_RESIDENTS_BY_SOKET;
    payload: CountInNode;
}
export interface IUpdateCountOfDevicesBySocket {
    type: typeof ORGANIZATION.UPDATE_COUNT_OF_DEVICES_BY_SOKET;
    payload: CountInNode;
}

export interface IGetAllNodesInfoRequest {
    type: typeof ORGANIZATION.GET_ALL_NODES_INFO_REQUEST;
    payload: number;
}

export interface IGetAllNodesInfoSuccess {
    type: typeof ORGANIZATION.GET_ALL_NODES_INFO_SUCCESS;
    payload: any;
}

export interface IGetAllNodesInfoFailure {
    type: typeof ORGANIZATION.GET_ALL_NODES_INFO_FAILURE;
    payload: any;
}

export interface IAddNodeBranchRequest {
    type: typeof ORGANIZATION.ADD_NODE_BRANCH_REQUEST;
    payload: AddNodeBranchDTO;
}

export interface IAddNodeBranchSuccess {
    type: typeof ORGANIZATION.ADD_NODE_BRANCH_SUCCESS;
    payload: { id: number; data: AddNodeDTO };
}

export interface IAddNodeBranchFailure {
    type: typeof ORGANIZATION.ADD_NODE_BRANCH_FAILURE;
    payload: any;
}

export interface IGetAddNodeBranchBySocket {
    type: typeof ORGANIZATION.RECEIVE_NODE_BRANCH_ADDED_BY_SOCKET;
    payload: any;
}

export interface ISetOrganizationIdFromToken {
    type: typeof ORGANIZATION.SET_ORGANIZATION_ID_FROM_TOKEN;
    payload: number;
}

export type OrganizationActionType =
    | IAddNodeFailure
    | IAddNodeRequest
    | IAddNodeSuccess
    | IDeleteNodeFailure
    | IDeleteNodeRequest
    | IDeleteNodeSuccess
    | IEditNodeFailure
    | IEditNodeRequest
    | IEditNodeSuccess
    | IOrganizatioGetInfoRequest
    | ICreateOrganization
    | ICreateOrganizationSuccess
    | ICreateOrganizationFailure
    | IOrganizationGetInfoSuccess
    | IGetOrganizationHistoryRequest
    | IGetOrganizationHistorySuccess
    | IGetOrganizationGHistoryFailure
    | IUpdateOrganizationNodeBySocket
    | IOrganizationPageActive
    | IUpdateCountOfResidentsBySocket
    | IUpdateCountOfDevicesBySocket
    | IGetAllNodesInfoRequest
    | IGetAllNodesInfoSuccess
    | IGetAllNodesInfoFailure
    | IAddNodeBranchFailure
    | IAddNodeBranchRequest
    | IAddNodeBranchSuccess
    | IGetAddNodeBranchBySocket
    | IUpdateOrganizationBySocket
    | IOrganizationGetInfoFailure
    | IOrganizationGetInfoSuccess
    | ISetSettingsOrganization
    | IUpdateOrganizationImageBySocket
    | IOrganizationGetDetailsFailure
    | IUpdateOrganizationNodeImageBySocket
    | ISetOrganizationIdFromToken;
